export const BrDataTableVariants = Object.freeze({
    Default: 'default',
    Glass: 'glass'
});

export type BrDataTableVariant = (typeof BrDataTableVariants)[keyof typeof BrDataTableVariants];
